import { render, staticRenderFns } from "./NovaImportacaoModal.vue?vue&type=template&id=f5a7d0e6&scoped=true"
import script from "./NovaImportacaoModal.vue?vue&type=script&lang=ts"
export * from "./NovaImportacaoModal.vue?vue&type=script&lang=ts"
import style0 from "./NovaImportacaoModal.vue?vue&type=style&index=0&id=f5a7d0e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5a7d0e6",
  null
  
)

export default component.exports